import Constants from '@/Constants';
import { EntityType } from '@/models/EntityTypes';
import { ApplicationState } from '@/store';
import React from 'react';
import { useSelector } from 'react-redux';
import FavoriteSection from '../FavoriteSection';
import './style.scss';

interface Entity {
    id: number;
    type: EntityType;
    name: string;
}

interface Props {
    entity: Entity;
    moduleId: number;
    hasFavorite?: boolean;
    hasAttachments?: boolean;
    hasComments?: boolean;
}

const HorizontalMenu: React.FC<Props> = ({ entity, moduleId, hasFavorite = false, hasAttachments = false, hasComments = false }: Props) => {
    const { strings, totalAttachments, totalComments } = useSelector((state: ApplicationState) => ({
        strings: state.locale.data,
        totalAttachments: state.attachments.data.length,
        totalComments: state.highlights.data.highlightListSize,
    }));

    const showMenu: boolean = hasFavorite || hasAttachments || hasComments;

    const scrollTo = (event: React.MouseEvent<HTMLElement, MouseEvent>, id: string) => {
        event.preventDefault();
        const element: HTMLElement = document.getElementById(id) as HTMLElement;
        const contentGoBackBar: HTMLElement = document.getElementById(Constants.CONTENT_GO_BACK_BAR_ID) as HTMLElement;
        const topImg: HTMLElement = document.getElementById(Constants.TOP_IMG_ID) as HTMLElement;

        if (element && contentGoBackBar && topImg) {
            window.scroll({
                behavior: 'smooth',
                left: 0,
                top: element.offsetTop + topImg.offsetHeight,
            });
        }
    };

    return (
        <>
            {showMenu && (
                <div className="horizontal-menu">
                    {hasFavorite && (
                        <FavoriteSection
                            customActiveClass="active"
                            customClass="horizontal-menu__link"
                            description={strings.FAVORITE}
                            descriptionCustomClass="horizontal-menu__link-description"
                            entityId={entity.id}
                            entityName={entity.name}
                            entityType={entity.type}
                            innerCustomClass="horizontal-menu__link-icon"
                            moduleId={moduleId}
                        />
                    )}

                    {hasAttachments && (
                        <button
                            className="horizontal-menu__link"
                            onClick={(e: React.MouseEvent<HTMLElement, MouseEvent>) => scrollTo(e, Constants.ATTACHMENTS_SECTION_ID)}
                        >
                            <i className="material-icons horizontal-menu__link-icon">{Constants.icons.ATTACH_OUTLINE}</i>
                            <span className="horizontal-menu__link-description lowercase">
                                {`${totalAttachments}  ${totalAttachments <= 1 ? strings.ATTACHMENT : strings.ATTACHMENTS}`}
                            </span>
                        </button>
                    )}

                    {hasComments && (
                        <button
                            className="horizontal-menu__link"
                            onClick={(e: React.MouseEvent<HTMLElement, MouseEvent>) => scrollTo(e, Constants.COMMENTS_SECTION_ID)}
                        >
                            <i className="material-icons-outlined horizontal-menu__link-icon">{Constants.icons.COMMENTS}</i>
                            <span className="horizontal-menu__link-description">{`${totalComments} ${totalComments > 1 ? strings.COMMENTS.toLocaleLowerCase() : strings.COMMENT.toLocaleLowerCase()}`}</span>
                        </button>
                    )}
                </div>
            )}
        </>
    );
};

export default HorizontalMenu;
